import { getAppEnvironment, type AppEnvironment } from "./app-environment";

export interface AppBuildInfo {
  environment: AppEnvironment;
  gitSha: string;
  gitShaShort: string;
}

export function getAppBuildInfo(): AppBuildInfo {
  const gitSha = import.meta.env.VITE_GIT_SHA?.trim() || "unknown";
  const gitShaShort =
    gitSha.length >= 7 && gitSha !== "unknown" ? gitSha.slice(0, 7) : gitSha;
  return {
    environment: getAppEnvironment(),
    gitSha,
    gitShaShort,
  };
}
